import React, {Component} from 'react';
import classNames from 'classnames';
import {OPERATION_LABEL, VISIT_SCHEDULE, WHITOUT_INFORMATION} from '../../utils/constants';
import * as dataService from '../../service/data-info-chart/requestsUtil';
import * as cbu from '../../utils/checkBusinessUnit';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

import 'react-table/react-table.css';
import * as Parse from '../../utils/parsers';

var Loader = require('react-loader');

class RegistrationMatrix extends Component {

  constructor(props) {
    super(props);

    var moment = require('moment');
    require('moment/min/locales.min');
    var today = Parse.toCustomDateLastDay(this.props.date);

    this.state = {
      buId: cbu.checkBusinessUnit(this.props.bu),
      datas: [],
      max: 0,
      date: today,
      dateMoment: moment(today),
      loaded: false,
      currentPage: 0,
      totalPages: 0,
      key: 0,
    };

    this.handleChange = this.handleChange.bind(this);
    this._Fetch = this._Fetch.bind(this);
    this.fetchMore = this.fetchMore.bind(this);
  }

  componentDidMount() {
    this._Fetch(this.state.date);
  }

  _Fetch(datep) {
    dataService.getFetch(OPERATION_LABEL + cbu.checkBusinessUnit(this.props.bu) + VISIT_SCHEDULE + datep + '?page=0&size=10')
      .then((json) => {
        if (json.length !== 0) {
          this.setState({
            datas: json.data.visits,
            max: json.data.maxVisits + 1,
            currentPage: json.pageNumber,
            totalPages: json.totalPages,
            loaded: true,
          });
        } else {
          this.setState({
            loaded: true
          });
        }
      });
  }

  fetchMore = (more) => {
    this.setState({
      loaded: false
    });
    dataService.getFetch(OPERATION_LABEL + this.state.buId + VISIT_SCHEDULE + this.state.date + '?page=' + (more ? (this.state.currentPage + 1) : (this.state.currentPage - 1)) + '&size=10')
      .then((json) => {
        this.setState({
          datas: json.data.visits,
          max: json.data.maxVisits + 1,
          currentPage: json.pageNumber,
          totalPages: json.totalPages,
          loaded: true,
        });
      });
  };

  handleChange(date) {
    var moment = require('moment');
    var datep = moment(date)
      .format('YYYY/MM/DD')
      .replace(/\//g, '');
    this.setState({
      dateMoment: date,
      loaded: false
    });
    this.setState({date: datep}, function stateUpdateComplete() {
      this._Fetch(datep);
    }.bind(this));
  }

  render() {

    const tableClass = classNames({
      'table': true,
      'table-striped': this.props.striped,
      'table-bordered': true,
      'table-hover': this.props.hover,
      'table-condensed': this.props.condensed
    });

    let rows = this.state.max >= 0 ? this.state.datas.map(visit => {
      return <TableRow name={visit.agent} visits={visit.visits} max={this.state.max}
                       total={visit.total} job={visit.job}/>;
    }) : <div style={{
      textAlign: 'center',
      marginTop: '15px',
      fontSize: '20px',
      // marginLeft: '-50%'
    }}><b>{WHITOUT_INFORMATION}</b></div>;

    var buttons;

    if (this.state.totalPages === 0 || ((this.state.currentPage + 1 === this.state.totalPages) && this.state.totalPages === 1)) {
      buttons = <div className={'container-flex p-1'}>
        <div className="d-flex justify-content-between">
          <button className={'btn btn-secondary'} disabled={'disabled'}> Anterior</button>
          <h5>Página 1 de 1</h5>
          <button className={'btn btn-secondary'} disabled={'disabled'}> Siguiente</button>
        </div>
      </div>;
    } else {
      if (this.state.currentPage === 0) {
        buttons = <div className={'container-flex p-1'}>
          <div className="d-flex justify-content-between">
            <button className={'btn btn-secondary'} disabled={'disabled'}> Anterior</button>
            <h5>Página {this.state.currentPage + 1} de {this.state.totalPages}</h5>
            <button className={'btn btn-secondary'}
                    onClick={() => this.fetchMore(true)}> Siguiente
            </button>
          </div>
        </div>;
      } else {
        if (this.state.currentPage + 1 === this.state.totalPages) {
          buttons = <div className={'container-flex p-1'}>
            <div className="d-flex justify-content-between">
              <button className={'btn btn-secondary'}
                      onClick={() => this.fetchMore(false)}> Anterior
              </button>
              <h5>Página {this.state.currentPage + 1} de {this.state.totalPages}</h5>
              <button className={'btn btn-secondary'} disabled={'disabled'}> Siguiente</button>
            </div>
          </div>;
        } else {
          buttons = <div className={'container-flex p-1'}>
            <div className="d-flex justify-content-between">
              <button className={'btn btn-secondary'}
                      onClick={() => this.fetchMore(false)}> Anterior
              </button>
              <h5>Página {this.state.currentPage + 1} de {this.state.totalPages}</h5>
              <button className={'btn btn-secondary'}
                      onClick={() => this.fetchMore(true)}> Siguiente
              </button>
            </div>
          </div>;
        }
      }
    }

    return (
      <div>
        <div className={'container-flex p-1'}>
          <div className="datepick justify-content-between">
            <h5 className={'align-middle'}>Matríz de gestiones</h5>
            <div className={'d-flex justify-content-end'}>
              <p className={'mr-1'}><b>Seleccionar fecha:</b></p>
              <DatePicker className={'mr-md-5 mr-0'}
                          key={this.state.key}
                          id={'datepicker'}
                          style={{width: '94px'}}
                          selected={this.state.dateMoment}
                          onChange={this.handleChange}
                          dateFormat="YYYY/MM/DD"/>
            </div>
          </div>
        </div>
        <Loader loaded={this.state.loaded}>
          <div className='table-scroll-matrix'>
            <table className={tableClass}>
              <TableHeader key={this.state.dateMoment + '1'} max={this.state.max}/>
              <tbody>
              {rows}
              </tbody>
            </table>
          </div>
          <div>
            {buttons}
          </div>
        </Loader>
      </div>
    );
  }
}

const TableHeader = (props) => {

  let cols = props.max >= 0 ? [<th className={'align-middle'} style={{minWidth: '200px'}}
                                   key={0}>Inicio de labores</th>] : [];
  for (var i = 1; i <= props.max - 1; i++) {
    cols.push(<th className={'align-middle'} key={i}>{i}</th>);
  }

  return (
    <thead className={'p-2'} style={{
      color: '#FFF',
      backgroundColor: '#78909C'
    }}>
    <tr style={{height: '29px'}}>
      <th className='align-middle col-matrix-header'>Nombre</th>
      <th className='col-matrix2-header'>Puesto</th>
      <th className='text-center align-middle col-matrix3-header'>Resumen</th>
      {cols}
    </tr>
    </thead>
  );
};

const TableRow = (props) => {

  let cols = [];

  for (var i = 0; i < props.max; i++) {
    if (i + 1 <= props.visits.length) {
      cols.push(<td key={i - 1}>{props.visits[i].time}</td>);
    } else {
      cols.push(<td key={i - 1}>-</td>);
    }
  }

  return (
    <tr>
      <td className='col-matrix'>{props.name}</td>
      <td className='col-matrix2'>{props.job}</td>
      <td className='text-center col-matrix3'>{props.total}</td>
      {cols}
    </tr>
  );
};

export default RegistrationMatrix;



// WEBPACK FOOTER //
// ./src/components/tables/registrationMatrix.js